var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  MATRICES_FUNCTIONS: () => MATRICES_FUNCTIONS,
  MATRICES_FUNCTION_TRANSLATE: () => MATRICES_FUNCTION_TRANSLATE,
  default: () => matrices_default
});
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
var import_math = __toModule(require("../helper/math"));
var import_utils = __toModule(require("../helper/utils"));
const MATRICES_FUNCTION_TRANSLATE = {
  "CALCULA DIAS MATRICES": "dateCalculateDaysMatrices",
  "CONCATENAR MATRICES": "concatenateMatrices",
  "CONTIENE TEXTO MATRICES": "containTextMatrices",
  "DISTINTO MATRICES": "unequalMatrices",
  "DISTINTO TEXTO MATRICES": "unequalTextMatrices",
  "DIVISION MATRICES": "divideMatrices",
  "IGUAL MATRICES": "equalMatrices",
  "INCLUYE MISMO TEXTO MATRICES": "includeEqualTextMatrices",
  "INCLUYE TEXTO MATRICES": "includeTextMatrices",
  "INDEX MATRICES": "indexOfMatrices",
  "INDEX PRIMER TEXTO MATRICES": "indexFirstTextValueMatrices",
  "INDEX MAXIMO MATRICES": "indexMaximumMatrices",
  "INDEX MINIMO MATRICES": "indexMinimumMatrices",
  "INDEX SUMA MATRICES": "indexSumMatrices",
  "MATCH NUMERO MATRICES": "matchNumberMatrices",
  "MATCH TEXTO MATRICES": "matchTextMatrices",
  "MAXIMO MATRICES": "maximumMatrices",
  "MAYOR MATRICES": "largerMatrices",
  "MAYOR O IGUAL MATRICES": "largerEqMatrices",
  "MENOR MATRICES": "smallerMatrices",
  "MENOR O IGUAL MATRICES": "smallerEqMatrices",
  "MINIMO MATRICES": "minimumMatrices",
  "MISMO TEXTO MATRICES": "equalTextMatrices",
  "MULTIPLICACION MATRICES": "multiplyMatrices",
  "NO CONTIENE TEXTO MATRICES": "notContainTextMatrices",
  "NO INCLUYE MISMO TEXTO MATRICES": "notIncludeEqualTextMatrices",
  "NO INCLUYE TEXTO MATRICES": "notIncludeTextMatrices",
  "RESTA MATRICES": "subtractMatrices",
  "SUMA MATRICES": "addMatrices"
};
const MATRICES_FUNCTIONS = Object.values(MATRICES_FUNCTION_TRANSLATE);
const addMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.addFunction, ...values);
};
const concatenateMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.concatenateFunction, ...values);
};
const containTextMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.containTextFunction, ...values);
};
const dateCalculateDaysMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.dateCalculateDaysFunction, ...values);
};
const divideMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.divideFunction, ...values);
};
const equalMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.equalFunction, ...values);
};
const equalTextMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.equalTextFunction, ...values);
};
const includeEqualTextMatrices = import_math.includeEqualTextFunction;
const includeTextMatrices = import_math.includeTextFunction;
const indexFirstTextValueMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(indexFirstTextValueMatrices, import_math.indexFirstTextValueFunction, valueA, valueB);
};
const indexOfMatrices = (valueA, valueB) => {
  if (!Array.isArray(valueB)) {
    const message = `Function indexOfMatrices. Operand 2 is not a matrix ${valueB}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  valueB.forEach((elementB, index) => {
    if (!Array.isArray(elementB)) {
      const message = `Function indexOfMatrices. Operand 2 at position ${index} is not a matrix ${elementB}`;
      throw new import_mathFunctionError.MathFunctionError(message);
    }
  });
  return (0, import_utils.operateMatricesOneToMany)(indexOfMatrices, import_math.indexFunction, valueA, valueB);
};
const indexMaximumMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(indexMaximumMatrices, import_math.indexMaximumFunction, valueA, valueB);
};
const indexMinimumMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(indexMinimumMatrices, import_math.indexMinimumFunction, valueA, valueB);
};
const indexSumMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(indexSumMatrices, import_math.indexSumFunction, valueA, valueB);
};
const largerMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.largerFunction, ...values);
};
const largerEqMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.largerEqFunction, ...values);
};
const matchNumberMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(matchNumberMatrices, import_math.matchNumberFunction, valueA, valueB);
};
const matchTextMatrices = (valueA, valueB) => {
  return (0, import_utils.operateMatricesOneToMany)(matchTextMatrices, import_math.matchTextFunction, valueA, valueB);
};
const smallerMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.smallerFunction, ...values);
};
const smallerEqMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.smallerEqFunction, ...values);
};
const maximumMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.maximumFunction, ...values);
};
const minimumMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.minimumFunction, ...values);
};
const multiplyMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.multiplyFunction, ...values);
};
const notContainTextMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.notContainTextFunction, ...values);
};
const notIncludeEqualTextMatrices = import_math.notIncludeEqualTextFunction;
const notIncludeTextMatrices = import_math.notIncludeTextFunction;
const subtractMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.subtractFunction, ...values);
};
const unequalMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.unequalFunction, ...values);
};
const unequalTextMatrices = (...values) => {
  return (0, import_utils.operateMatrices)(import_math.unequalTextFunction, ...values);
};
var matrices_default = {
  addMatrices,
  concatenateMatrices,
  containTextMatrices,
  dateCalculateDaysMatrices,
  divideMatrices,
  equalMatrices,
  equalTextMatrices,
  includeEqualTextMatrices,
  includeTextMatrices,
  indexFirstTextValueMatrices,
  indexOfMatrices,
  indexMaximumMatrices,
  indexMinimumMatrices,
  indexSumMatrices,
  largerEqMatrices,
  largerMatrices,
  matchNumberMatrices,
  matchTextMatrices,
  maximumMatrices,
  minimumMatrices,
  multiplyMatrices,
  notContainTextMatrices,
  notIncludeEqualTextMatrices,
  notIncludeTextMatrices,
  smallerEqMatrices,
  smallerMatrices,
  subtractMatrices,
  unequalMatrices,
  unequalTextMatrices
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MATRICES_FUNCTIONS,
  MATRICES_FUNCTION_TRANSLATE
});
